export default function Playground() {
  return <>{/* <!--placeholder--> */}</>;
}
